import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { ref } from "vue";
import { useIntervalFn } from "@vueuse/core";
import moment from "moment";
import { getData } from "@/services/axios";
export default {
  __name: 'LatestSchoolForum',
  setup: function setup(__props) {
    // @ts-check
    var fiscalYear = moment().add(-3, "month").year();
    var forumList = ref([]);

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getData("school_forums?from=".concat(fiscalYear, "-04-01&to=").concat(fiscalYear + 1, "-03-31&limit=10"));

              case 3:
                data = _context.sent;
                forumList.value = data.items;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }(); // 毎分更新


    useIntervalFn(function () {
      setData();
    }, 60000);
    setData();
    return {
      __sfc: true,
      fiscalYear: fiscalYear,
      forumList: forumList,
      setData: setData,
      moment: moment
    };
  }
};